import { render, staticRenderFns } from "./UserNotificationList.vue?vue&type=template&id=409799f3&"
import script from "./UserNotificationList.vue?vue&type=script&lang=js&"
export * from "./UserNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports